import { IRequestData, IResponseData } from './find-information-for-ip-ul.type';
import axios from 'axios';

declare module 'axios' {
    export interface AxiosRequestConfig {
        skipGlobalError?: boolean;
    }
}

const API_BASE = '/services/isnaportal/open-api/sur';

export const getSurData = async (payload: IRequestData) => {
    const { data } = await axios.post<IResponseData>(
        `${API_BASE}/get-sur-data`,
        {
            xin: payload.xin,
            recaptchaToken: payload.recaptchaToken,
        },
        {
            skipGlobalError: true,
        }
    );
    return data;
};

export const downloadExcel = async (payload: IRequestData): Promise<Blob> => {
    const { data } = await axios.post(
        `${API_BASE}/get-sur-pdf`,
        {
            xin: payload.xin,
            recaptchaToken: payload.recaptchaToken,
        },
        {
            params: { lang: 'RU' },
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' },
        }
    );
    return data;
};
